import ApiService from './api.service';

export function index(params = {}) {
  return ApiService.query('notifications', params)
    .then((response) => {
      return response.data;
    });
}

export function show(id, params = {}) {
  return ApiService.get('notifications', id, params)
    .then((response) => {
      return response.data;
    });
}

export function create(params) {
  return ApiService.post('notifications', params)
    .then((response) => {
      return response.data;
    });
}

export function update(id, params) {
  return ApiService.update('notifications', id, params)
    .then((response) => {
      return response.data;
    });
}

export function destroy(id) {
  return ApiService.destroy(`notifications/${id}`);
}

export function markAsRead(id) {
  const params = {read: true};
  return ApiService.update('notifications', id, params)
    .then((response) => {
      return response.data;
    });
}

export default {
  index,
  show,
  create,
  update,
  destroy,
  markAsRead
};
